import styled from "styled-components";
import { Headline } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const StyledFieldset = styled.fieldset`
  width: 100%;
`;

export const PresetMobileWrapper = styled.div`
  #customSizes-Content {
    margin: 0;
    width: 100%;
  }

  #defaultSizes-content {
    margin: var(--dui-size-space-5x) 0 var(--gaq-size-space--5px);
  }
`;

export const PresetDesktopWrapper = styled.div`
  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-top: var(--dui-size-space-9x);
    padding-bottom: 0;
    margin-top: var(--dui-size-space-10x);
    border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-600);
  }
`;

export const StyledPresetsHeadline = styled(Headline)`
  margin-top: 0;
  margin-bottom: var(--dui-size-space-4x);

  @media print {
    display: none;
  }
`;
